import React from 'react';
import heroimg from '../assests/Untitled design (1).png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { faCode } from '@fortawesome/free-solid-svg-icons';

const Home = () => {
    return (
        <div className="hero" id="home">
            <div className="hero-overlay">
                <div className="description">
                    <h2 className="title">Hello, I am Arul</h2>
                    <h3 className="tagline">Eat -&gt; Sleep -&gt; Code -&gt; Repeat</h3>
                    <p className="paragraph">
                        Hello! I am currently pursuing my education at K.S.Rangasamy College of Technology, where I have been excelling academically with a remarkable CGPA of 8.84 in the first five semesters. My major coursework focuses on essential subjects such as Operating Systems, Database Management Systems, Computer Networks, Object-Oriented Programming, Data Structures, and Algorithms. Since beginning my educational journey in 2022, I have been dedicated to expanding my knowledge and skills in the field of Computer Science. With an expected graduation year of 2026, I am eager to leverage my education to contribute meaningfully to the world of technology and embark on exciting opportunities.
                    </p>
                    <div className="hero-btns">
                        <button className="hire-me">
                            <a href="https://drive.google.com/file/d/1wt_LWyXrrMQHYjj0PXH6wZZWPmERS1Xc/view?usp=sharing" target="_blank" rel="noreferrer">Get My Resume</a>
                        </button>
                        <button className="lets-talk">
                            <a href="#contact">Hire Me</a>
                        </button>
                    </div>
                </div>
                <img src={heroimg} alt="Arul" className="hero-image" />
            </div>
            <div className="social-icons">
                <a href="https://github.com/ArulG2005" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGithub} className="fa-icon" />
                </a>
                <a href="https://www.linkedin.com/in/arul2005/" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} className="fa-icon" />
                </a>
                <a href="https://play.google.com/store/apps/dev?id=7152012900864371035" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGooglePlay} className="fa-icon" />
                </a>
                <a href="https://linktr.ee/arul2005" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faCode} className="fa-icon" />
                </a>
            </div>
        </div>
    );
};

export default Home;
